import React from "react";
import axiosInstance from "../axiosConfig";

class ReferralPartnerServices extends React.Component {
  getAllReferralPartner = async ({ queryKey }) => {
    const [_key, data] = queryKey;
    let newData = {};
    const keys = Object.keys(data);
    keys.forEach((key, index) => {
      if (data[key]) {
        newData[key] = data[key];
      }
    });
    return await axiosInstance.get(`/api/referral-partner/list`, { params: newData });
  };

  downloadReport = async () => {
    // const [_key] = queryKey;
    axiosInstance.defaults.headers.put["responseType"] = "blob";
    return await axiosInstance.post(`/api/referral-partner/export`);
  };

  updateReferralPartnerStatus = async (id, status, remark) => {
    return await axiosInstance.post(`/api/referral-partner/update/status_vendor/${id}`, {
      is_enabled: status,
      remark,
    });
  };
  updateReferralPartnersStatus = async (id, status, remark) => {
    return await axiosInstance.post(`/api/referral-partner/update/status_vendor/${id}`, status);
  };

  updateReferralPartnerRequest = async (id, status, remark) => {
    return await axiosInstance.post(`/api/referral-partner/status/${id}`, {
      status,
      remark,
    });
  };

  getReferralPartnerDetails = async ({ queryKey }) => {
    const [_Key, { id }] = queryKey;
    if (id) {
      return await axiosInstance.get(`/api/referral-partner/edit/${id}`);
    }
  };

  updateReferralPartner = async (id, payload) => {
    if (id && payload) {
      return await axiosInstance.post(`/api/referral-partner/update/${id}`, payload);
    }
  };

  downloadSingleDocument = async (id) => {
    return await axiosInstance.get(`/api/referral-partner/download/${id}`, {
      responseType: "arraybuffer",
    });
  };

  getAllReferralCoupons = async ({ queryKey }) => {
    const [_key, data] = queryKey;
    let newData = {};
    const keys = Object.keys(data);
    keys.forEach((key, index) => {
      if (data[key]) {
        newData[key] = data[key];
      }
    });
    return await axiosInstance.get(`/api/referral-coupons-list`, { params: newData });
  };

  generateCoupon = async () => {
    return await axiosInstance.get(`/api/generate-referral-coupon`);
  };
  
  addCoupon = async (payload) => {
    return await axiosInstance.post(`/api/add-referral-coupon`, payload);
  };

  editCoupon = async (id) => {
    return await axiosInstance.get(`/api/edit-referral-coupon/${id}`);
  };

  updateCoupon = async (id, payload) => {
    return await axiosInstance.post(`/api/update-referral-coupon/${id}`, payload);
  };

  updateCouponStatus = async (id, status, remark) => {
    return await axiosInstance.post(`/api/update-referral-coupon-status/${id}`, status);
  };

  downloadCouponReport = async () => {
    axiosInstance.defaults.headers.put["responseType"] = "blob";
    return await axiosInstance.post(`/api/export-referral-coupon`);
  };

  getUserCouponDetails = async (id) => {
    return await axiosInstance.post(`/api/get-partner-coupon-details`, id);
  };
}

const instance = new ReferralPartnerServices();

export default instance;
